import { render, staticRenderFns } from "./OpenFileButton.vue?vue&type=template&id=f23d5c14&scoped=true"
import script from "./OpenFileButton.vue?vue&type=script&lang=ts"
export * from "./OpenFileButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23d5c14",
  null
  
)

export default component.exports